import http from '@/utils/http';

export default {
	list: data => {
		return http({ url: '/api/admin/v1/demand/list', data }).then(r => r);
	},
	detail: data => {
		return http({ url: '/api/admin/v1/demand/detail', data }).then(r => r);
	},
};
